import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createHeadingNode, HeadingTagType } from '@lexical/rich-text';
import { $setBlocksType } from '@lexical/selection';
import {
  $createParagraphNode,
  $getSelection,
  $isRangeSelection,
} from 'lexical';
import { BlockType } from '../types';
import styles from './BlockFormatDropdown.module.css';

type Props = {
  blockType: BlockType;
};

const blockTypeToLabel: Record<BlockType, string> = {
  paragraph: 'Body',
  h1: 'Heading 1',
  h2: 'Heading 2',
  h3: 'Heading 3',
};

export function BlockFormatDropdown({ blockType }: Props) {
  const [editor] = useLexicalComposerContext();

  function formatParagraph() {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $setBlocksType(selection, () => $createParagraphNode());
      }
    });
  }

  function formatHeading(headingSize: HeadingTagType) {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $setBlocksType(selection, () => $createHeadingNode(headingSize));
      }
    });
  }

  function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const value = e.target.value as BlockType;
    if (value === 'paragraph') {
      formatParagraph();
    } else {
      formatHeading(value as HeadingTagType);
    }
  }

  return (
    <div className={styles.dropdownWrapper}>
      <select
        className={styles.dropdown}
        value={blockType}
        onChange={handleChange}
        aria-label='Formatting options for text style'
      >
        <option value='paragraph'>{blockTypeToLabel.paragraph}</option>
        <option value='h1'>{blockTypeToLabel.h1}</option>
        <option value='h2'>{blockTypeToLabel.h2}</option>
        <option value='h3'>{blockTypeToLabel.h3}</option>
      </select>
    </div>
  );
}
